import React from 'react';
import { highlightParts } from '../lib/search';

export type HighlightProps = {
  text: string;
  terms: string[];
  /** Extra styles merged onto each highlighted run. */
  markStyle?: React.CSSProperties;
};

const MARK_STYLE: React.CSSProperties = {
  background: 'var(--accent-fill)', color: 'var(--accent)', borderRadius: 3, padding: '0 1px',
};

/** Render text with any matching query terms wrapped in an accent highlight. */
export function Highlight({ text, terms, markStyle }: HighlightProps) {
  return (
    <>
      {highlightParts(text, terms).map((part, i) =>
        part.hit ? (
          <mark key={i} style={{ ...MARK_STYLE, ...markStyle }}>{part.text}</mark>
        ) : (
          <React.Fragment key={i}>{part.text}</React.Fragment>
        )
      )}
    </>
  );
}

export default Highlight;
